var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',_vm._b({attrs:{"dense":"","floating":"","tag":"div"}},'v-toolbar',Object.assign({}, _vm.$attrs, _vm.$props),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }